import { client } from "../api/apolloClient";
import { PreLoginStoreFactory } from "@izi-logistics/common/lib/stores";

export const PreLoginStore = PreLoginStoreFactory({ client });
